export default "__VITE_ASSET__CL9v8imt__"